import {
  SET_NAVIGATION_MENU,
  SET_NAVIGATION_STYLE,
  SET_NAVIGATION_TEXT_COLOR,
  SET_NAVIGATION_TEXT_HOVER_COLOR,
  SET_NAVIGATION_ACCENT_COLOR,
} from './action-names';

export function setMenu(data) {
  return {
    type: SET_NAVIGATION_MENU,
    ...data
  };
};

export function setStyle(data) {
  return {
    type: SET_NAVIGATION_STYLE,
    ...data
  };
};

export function setTextColor(data) {
  return {
    type: SET_NAVIGATION_TEXT_COLOR,
    ...data
  };
};

export function setTextHoverColor(data) {
  return {
    type: SET_NAVIGATION_TEXT_HOVER_COLOR,
    ...data
  };
};

export function setAccentColor(data) {
  return {
    type: SET_NAVIGATION_ACCENT_COLOR,
    ...data
  };
};



// WEBPACK FOOTER //
// ./app/header-builder/actions/navigation-element-actions.js